import { useTranslation } from 'react-i18next';

import { Button } from '../components/Button';
import { useLocatorStore } from '../store/useLocatorStore';

import { AutoComplete } from './Map.AutoComplete';
import { ClinicList } from './Map.ClinicList';
import { RadiusModal } from './Map.RadiusModal';
// import { SortByModal } from './Map.SortByModal';

const BASE_URL = import.meta.env.VITE_BASE_URL;

type Props = {
  mapRef: any;
};

// eslint-disable-next-line no-empty-pattern
export function MapSidebar({}: Props) {
  const visibleClinics = useLocatorStore((state) => state.visibleClinics);
  const radius = useLocatorStore((state) => state.radius);
  const radiusUnit = useLocatorStore((state) => state.radiusUnit);
  const currentLocation = useLocatorStore((state) => state.currentLocation);
  const listType = useLocatorStore((state) => state.listType);
  const setListType = useLocatorStore((state) => state.setListType);

  const { t } = useTranslation();

  const oppositeListType = listType === 'map' ? 'list' : 'map';
  const oppositeListTypeText = listType === 'map' ? t('list view') : t('map view');
  const radiusUnitTranslated = radiusUnit === 'km' ? t('km') : t('miles');

  return (
    <div className="flex h-full w-full flex-col">
      <RadiusModal />
      {/* <SortByModal /> */}

      <div className="h-[88px] bg-secondary px-[16px] py-[20px] md:px-[48px] md:py-[20px]">
        <AutoComplete />
      </div>

      <div
        className="flex h-full flex-col items-center md:overflow-y-scroll bg-white"
        id="map-sidebar"
      >
        <div className="mt-[20px] flex w-full justify-between px-[16px] md:px-[48px]">
          <Button
            disabled={!currentLocation}
            className="h-[44px] rtl:flex-row-reverse"
            type="toggle"
            onClick={() => {
              (document.getElementById('radius-modal') as HTMLFormElement).showModal();
            }}
          >
            <img
              src={`${BASE_URL}/assets/images/icons/radius.svg`}
              alt="map radius icon"
              className="mr-[8px] h-[17px] w-[17px] "
            />
            <span className="text-[12px] font-medium normal-case">
              <span className="capitalize">{t('radius')}</span>
              {!!Number(radius) &&
                radius !== 0 &&
                `: + ${radius} ${radiusUnitTranslated.toLocaleLowerCase()}`}
              {radius === undefined && `: ${t('map area')}`}
            </span>
          </Button>

          {/* <Button
            disabled={!currentLocation}
            className="h-[44px] rtl:flex-row-reverse"
            type="toggle"
            onClick={() => {
              (document.getElementById('sort-by-modal') as HTMLFormElement).showModal();
            }}
          >
            <img
              src={`${BASE_URL}/assets/images/icons/arrows.svg`}
              alt="sort icon"
              className="mr-[8px] h-[11px] w-[15px]"
            />
            <span className="text-[12px] font-medium normal-case">{t('Sort by')}</span>
          </Button> */}
        </div>

        <div className="flex w-full items-center  justify-between px-[16px] py-[22px] text-left text-[1em] font-medium md:px-[48px]">
          <span>
            {visibleClinics.length} {t('results')}
          </span>
          <span
            className="flex cursor-pointer items-center gap-1 md:tw-hidden"
            onClick={() => setListType(oppositeListType)}
          >
            <img
              src={`${BASE_URL}/assets/images/icons/${oppositeListType}.svg`}
              alt="toggle icon"
              className="ml-[8px] h-[24px] w-[24px]"
            />
            <span className="text-[12px] font-medium capitalize">{oppositeListTypeText}</span>
          </span>
        </div>

        <div className="tw-hidden w-full md:block">
          <ClinicList />
        </div>
      </div>
    </div>
  );
}
